export enum DomainKeyEnum {
    Amount = "DO_AMOUNT",
    AmountDecimal = "DO_AMOUNT_DECIMAL",
    Boolean = "DO_BOOLEAN",
    Date = "DO_DATE",
    DateTime = "DO_DATETIME",
    Days = "DO_DAYS",
    IdName = "DO_ID_NAME",
    MarketingActionStatus = "DO_MARKETING_ACTION_STATUS",
    ServiceTime = "DO_SERVICE_TIME",
    Time = "DO_TIME",
}
